import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import { TenantProvider } from './context/TenantContext';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MfaEnroll from './pages/MfaEnroll';
import FollowConfirm from './pages/FollowConfirm';
import Dashboard from './pages/Dashboard';
import ProjectDetail from './pages/ProjectDetail';
import Settings from './pages/Settings';
import Partners from './pages/Partners';
import PublicProject from './pages/PublicProject';
import CompanyPublicPage from './pages/CompanyPublicPage';
import MentionsLegales from './pages/MentionsLegales';
import CGU from './pages/CGU';
import CGV from './pages/CGV';
import Confidentialite from './pages/Confidentialite';
import SousTraitance from './pages/SousTraitance';
import Header from './components/Header';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Chargement...</div>;
  return user ? children : <Navigate to="/login" />;
}

function AppRoutes() {
  const { user } = useAuth();
  const location = useLocation();
  const publicPaths = location.pathname === '/'
    || location.pathname.startsWith('/chantier/')
    || location.pathname.startsWith('/e/');
  const showHeader = user && !publicPaths;

  return (
    <>
      {showHeader && <Header />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verifier-email" element={<VerifyEmail />} />
        <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
        <Route path="/reinitialiser-mot-de-passe" element={<ResetPassword />} />
        <Route path="/mfa-enrolement" element={<MfaEnroll />} />

        {/* Pages légales : accessibles depuis tous les domaines de la plateforme */}
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/cgu" element={<CGU />} />
        <Route path="/cgv" element={<CGV />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
        <Route path="/sous-traitance" element={<SousTraitance />} />
        <Route path="/suivi/confirmer" element={<FollowConfirm />} />
        <Route path="/suivi/desabonnement" element={<FollowConfirm />} />

        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/project/:id" element={<PrivateRoute><ProjectDetail /></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
        <Route path="/partners" element={<PrivateRoute><Partners /></PrivateRoute>} />

        {/* Pages publiques par tenant */}
        <Route path="/e/:companySlug" element={<CompanyPublicPage />} />
        <Route path="/e/:companySlug/chantier/:slug" element={<PublicProject />} />

        {/* URL historique des QR imprimés — garantie à vie */}
        <Route path="/chantier/:slug" element={<PublicProject />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <ToastContainer position="bottom-right" autoClose={3000} />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <TenantProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </TenantProvider>
    </BrowserRouter>
  );
}
